import React, { useMemo } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import { useConfigureFooter } from "~hooks/useHelpers";
import { InputGroup, Select } from "@chakra-ui/react";
import ListagemMapaeVisitas from "./ListagemMapaeVisitas";
import { todasAsDatasDoMes } from "~services/GlobalServices";

const RotaDoDiaListagemVisitas = ({
  visitas,
  totalRenderizado,
  total,
  isLoading,
  setFilters,
  filters,
  setIsLoading,
  setSkip,
  skip,
  take,
}) => {
  const dias = useMemo(() => todasAsDatasDoMes(), []);

  useConfigureFooter();

  const loadMoreItems = () => {
    setTimeout(() => {
      setSkip(skip + take);
    }, 1100);
  };

  const handleBack = () => {
    globalThis.history.back();
    setTimeout(() => {
      globalThis.location.reload();
    }, 100);
  };

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      {isLoading ? (
        <div>Carregando...</div>
      ) : (
        <div>
          <InfiniteScroll
            dataLength={totalRenderizado}
            next={loadMoreItems}
            hasMore={total > totalRenderizado}
            loader={<Loader />}
          >
            {visitas && visitas?.length > 0 && (
              <div className="container flex items-center justify-between mt-[28px]  ">
                <p className="flex-shrink-0 hidden md:block">
                  Exibindo {totalRenderizado} de {total}
                </p>
                <InputGroup className="flex-grow-0 flex-shrink-1 md:basis-1/4 text-primaria">
                  <p className="flex-grow-0 flex-shrink-0 mb-0 mr-2">Ordenar por:</p>
                  <Select
                    variant="unstyled"
                    className="w-auto font-bold focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                    id="periodo"
                    onChange={(e) => setFilters({ ...filters, ordem: e.target.value })}
                  >
                    <option value="1">Mais Recentes</option>
                    <option value="2">Mais Antigo</option>
                  </Select>
                </InputGroup>
              </div>
            )}

            {visitas && visitas.length > 0 ? (
              visitas.map((item) => (
                <ListagemMapaeVisitas
                  selectRoute={null}
                  visit={true}
                  item={item}
                  key={item.id || item.clienteId || `visita-${item.index}`}
                  dias={dias}
                />
              ))
            ) : (
              <div>
                <div className="container flex items-center justify-end mt-[28px]  ">
                  <InputGroup className="flex-grow-0 flex-shrink-1 md:basis-1/4 text-primaria">
                    <p className="flex-grow-0 flex-shrink-0 mb-0 mr-2">Ordenar por:</p>
                    <Select
                      variant="unstyled"
                      className="w-auto font-bold focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                      id="periodo"
                      onChange={(e) => setFilters({ ...filters, ordem: e.target.value })}
                    >
                      <option value="0">Todos</option>
                      <option value="1">Mais Recentes</option>
                      <option value="2">Antigas</option>
                    </Select>
                  </InputGroup>
                </div>
                <div className="text-center mt-10">
                  <p className="text-2xl font-bold mb-4">Nenhum dado encontrado!</p>
                  <button
                    onClick={handleBack}
                    className="px-4 py-2 back-link bg-primaria text-white rounded-md transition duration-300 ease-in-out hover:bg-concluido"
                  >
                    Voltar para página anterior
                  </button>
                </div>
              </div>
            )}
          </InfiniteScroll>
        </div>
      )}
    </>
  );
};

RotaDoDiaListagemVisitas.propTypes = {
  take: PropTypes.number.isRequired,
  visitas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      clienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      index: PropTypes.number,
    })
  ).isRequired,
  totalRenderizado: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    ordem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  setIsLoading: PropTypes.func.isRequired,
  setSkip: PropTypes.func.isRequired,
  skip: PropTypes.number.isRequired,
};

export default RotaDoDiaListagemVisitas;
